// START_MODULE repository_content
// START_CONTRACT
// PURPOSE: Store the announcements, curated community news and local image bindings previously supplied by the backend.
// OPERATIONAL_CONTEXT: Imported only by MainRepository; content changes are published through a normal repository commit and redeploy.
// CONTRACT: Every item has a stable id, ISO timestamp, local image id, concise maintained HTML and a source link when it comes from Telegram.
// KEYWORDS: mock-repository, announcements, news, static-content, telegram-archive
// COMPLEXITY: 3
// END_CONTRACT
import announcementImage from 'assets/gallery/2.jpg';
import communityLogo from 'assets/logo.jpg';
import meeting202602Image from 'assets/telegram/195-1.jpg';
import meeting202503Image from 'assets/telegram/171-1.jpg';
import meeting202412Image from 'assets/telegram/167-1.jpg';
import meeting20241207Image from 'assets/telegram/164-1.jpg';
import meeting202408Image from 'assets/telegram/154-1.jpg';
import meeting20240727Image from 'assets/telegram/150-1.jpg';
import meeting20240706Image from 'assets/telegram/139-1.jpg';
import tinkoffMeetingImage from 'assets/telegram/125-1.jpg';
import geoDataScienceImage from 'assets/telegram/119-1.jpg';
import textAnalyticsImage from 'assets/telegram/109-1.jpg';
import dataFestBreakfastImage from 'assets/telegram/106-2.jpg';
import firstMeetupImage from 'assets/telegram/92-1.jpg';
import firstRebrandMeetingImage from 'assets/telegram/90-1.jpg';
import rebrandImage from 'assets/telegram/82-1.jpg';
import reinforcementLearningImage from 'assets/telegram/41-2.jpg';
import magicSquaresImage from 'assets/telegram/34-1.jpg';
import medicalDataImage from 'assets/telegram/27-1.jpg';
import speechRecognitionImage from 'assets/telegram/23-1.jpg';
import firstDinnerImage from 'assets/telegram/16-1.jpg';
import communityLaunchImage from 'assets/telegram/10-1.jpg';

import { IAnnouncement } from 'domain/entities/IAnnouncement';
import { INews } from 'domain/entities/INews';

import { telegramNewsContent } from './telegramNewsContent';

// START_DATA image_sources
export const imageSources: Record<string, string> = {
  'announcement-next-meeting': announcementImage,
  'news-community-logo': communityLogo,
  'news-meeting-2026-02': meeting202602Image,
  'news-meeting-2025-03': meeting202503Image,
  'news-meeting-2024-12': meeting202412Image,
  'news-meeting-2024-12-07': meeting20241207Image,
  'news-meeting-2024-08': meeting202408Image,
  'news-meeting-2024-07-27': meeting20240727Image,
  'news-meeting-2024-07-06': meeting20240706Image,
  'news-tinkoff-career': tinkoffMeetingImage,
  'news-geo-data-science': geoDataScienceImage,
  'news-text-analytics': textAnalyticsImage,
  'news-datafest-breakfast': dataFestBreakfastImage,
  'news-first-meetup': firstMeetupImage,
  'news-first-rebrand-meeting': firstRebrandMeetingImage,
  'news-rebrand': rebrandImage,
  'news-reinforcement-learning': reinforcementLearningImage,
  'news-magic-squares': magicSquaresImage,
  'news-medical-data': medicalDataImage,
  'news-speech-recognition': speechRecognitionImage,
  'news-first-data-dinner': firstDinnerImage,
  'news-community-launch': communityLaunchImage,
};
// END_DATA image_sources

// START_DATA announcements
export const announcements: IAnnouncement[] = [
  {
    id: 'next-meeting',
    header: 'Следующая встреча',
    content: '<p>Дату, тему и место следующей встречи опубликуем в Telegram-канале.</p>',
    dateAdded: '2026-08-20T12:00:00.000Z',
    imageHeaderId: 'announcement-next-meeting',
  },
];
// END_DATA announcements

// START_DATA news
export const news: INews[] = [
  {
    id: 'ml-reality',
    header: 'Первый гибридный митап ML Reality',
    content: '<p>28 февраля провели первый гибридный митап ML Reality о работе ML-систем в продакшене: сложных данных, деградации моделей, инфраструктуре и инженерных компромиссах.</p>',
    dateAdded: '2026-03-03T09:08:19.000Z',
    imageHeaderId: 'news-community-logo',
    fullContent: telegramNewsContent[202],
    sourceUrl: 'https://t.me/dataDinnersTomsk/202',
  },
  {
    id: 'meeting-2026-02',
    header: 'Февральская встреча: 12 участников',
    content: '<p>14 февраля встретились в «Буланже»: обсудили накопившиеся темы, опыт трудоустройства и планы следующих встреч. Нас было двенадцать человек.</p>',
    dateAdded: '2026-02-14T12:35:44.000Z',
    imageHeaderId: 'news-meeting-2026-02',
    fullContent: telegramNewsContent[195],
    sourceUrl: 'https://t.me/dataDinnersTomsk/195',
  },
  {
    id: 'meeting-2025-03',
    header: 'Рекордная встреча в «Кафедре»',
    content: '<p>На встречу пришли 18 человек. Говорили о новых LLM, вспоминали важные этапы развития Data Science и обсуждали, куда движется отрасль.</p>',
    dateAdded: '2025-03-01T13:41:32.000Z',
    imageHeaderId: 'news-meeting-2025-03',
    fullContent: telegramNewsContent[171],
    sourceUrl: 'https://t.me/dataDinnersTomsk/171',
  },
  {
    id: 'meeting-2024-12',
    header: 'Итоги 2024: LLM и разработка',
    content: '<p>На последней встрече года Павел подвёл подробные итоги развития LLM и рассказал, как использовать их в разработке. Дискуссия продолжилась и после закрытия площадки.</p>',
    dateAdded: '2024-12-31T21:44:06.000Z',
    imageHeaderId: 'news-meeting-2024-12',
    fullContent: telegramNewsContent[167],
    sourceUrl: 'https://t.me/dataDinnersTomsk/167',
  },
  {
    id: 'meeting-2024-12-07',
    header: 'Каким может стать томский Data Science',
    content: '<p>На декабрьской встрече обсуждали новинки CV и NLP, эксперименты с o1 и то, какие задачи местного сообщества можно решать с помощью общения и профессионального нетворкинга.</p>',
    dateAdded: '2024-12-10T18:08:20.000Z',
    imageHeaderId: 'news-meeting-2024-12-07',
    fullContent: telegramNewsContent[164],
    sourceUrl: 'https://t.me/dataDinnersTomsk/164',
  },
  {
    id: 'meeting-2024-08',
    header: 'Проекты, статьи и компактные модели',
    content: '<p>На августовской встрече обсуждали идеи для pet-проектов, ML в нефтегазовой отрасли, распознавание рукописных формул и способы ускорять и уменьшать модели.</p>',
    dateAdded: '2024-09-01T12:13:33.000Z',
    imageHeaderId: 'news-meeting-2024-08',
    fullContent: telegramNewsContent[154],
    sourceUrl: 'https://t.me/dataDinnersTomsk/154',
  },
  {
    id: 'meeting-2024-07-27',
    header: 'Chaos engineering и мультиагентные системы',
    content: '<p>Девять участников обсуждали моделирование chaos engineering квантовыми графами, навигацию роверов и дронов и индивидуальные пути входа в Data Science.</p>',
    dateAdded: '2024-08-18T13:50:02.000Z',
    imageHeaderId: 'news-meeting-2024-07-27',
    fullContent: telegramNewsContent[150],
    sourceUrl: 'https://t.me/dataDinnersTomsk/150',
  },
  {
    id: 'meeting-2024-07-06',
    header: 'Квантованные модели, diffusion и RL',
    content: '<p>На июльском дата-обеде говорили о моделях с 8-битными и 1-битными весами, diffusion в NLP, распределённом обучении и сложностях reinforcement learning.</p>',
    dateAdded: '2024-07-06T15:44:19.000Z',
    imageHeaderId: 'news-meeting-2024-07-06',
    fullContent: telegramNewsContent[139],
    sourceUrl: 'https://t.me/dataDinnersTomsk/139',
  },
  {
    id: 'tinkoff-career',
    header: 'Поиск работы вместе с Tinkoff',
    content: '<p>На совместной встрече с Tinkoff разобрали резюме, стратегии поиска вакансий, отклики и общение с рекрутерами. Участники получили практические рекомендации для старта карьеры в IT.</p>',
    dateAdded: '2024-02-13T11:49:04.000Z',
    imageHeaderId: 'news-tinkoff-career',
    fullContent: telegramNewsContent[124],
    sourceUrl: 'https://t.me/dataDinnersTomsk/124',
  },
  {
    id: 'geo-data-science',
    header: 'Geo Data Science: где открыть новую точку',
    content: '<p>Владислав рассказал, как средствами Geo Data Science оценивать расположение новой точки продаж. Встреча, организованная по инициативе участника сообщества, собрала 15 человек.</p>',
    dateAdded: '2024-01-09T10:40:47.000Z',
    imageHeaderId: 'news-geo-data-science',
    fullContent: telegramNewsContent[119],
    sourceUrl: 'https://t.me/dataDinnersTomsk/119',
  },
  {
    id: 'year-2023',
    header: 'Итоги 2023 года',
    content: '<p>На последней встрече года обсуждали NLP и fraud detection, делились профессиональными итогами и говорили о карьерном росте, поиске работы и взаимодействии с HR.</p>',
    dateAdded: '2024-01-02T13:00:37.000Z',
    imageHeaderId: 'news-community-logo',
    fullContent: telegramNewsContent[116],
    sourceUrl: 'https://t.me/dataDinnersTomsk/116',
  },
  {
    id: 'text-analytics',
    header: 'Разбор доклада о текстовой аналитике',
    content: '<p>Вместе посмотрели доклад Антона Колонина о том, какие знания можно извлекать из текста, нашли упомянутые статьи и подробно обсудили предложенные подходы.</p>',
    dateAdded: '2023-10-21T18:54:14.000Z',
    imageHeaderId: 'news-text-analytics',
    fullContent: telegramNewsContent[109],
    sourceUrl: 'https://t.me/dataDinnersTomsk/109',
  },
  {
    id: 'datafest-breakfast',
    header: 'Обсуждаем Data Fest Siberia',
    content: '<p>Семнадцать участников собрались за завтраком, чтобы посмотреть один из докладов Data Fest Siberia, обменяться впечатлениями и развить прозвучавшие на фестивале идеи.</p>',
    dateAdded: '2023-10-15T14:27:02.000Z',
    imageHeaderId: 'news-datafest-breakfast',
    fullContent: telegramNewsContent[106],
    sourceUrl: 'https://t.me/dataDinnersTomsk/106',
  },
  {
    id: 'first-meetup',
    header: 'Первый Tomsk Data Science Meetup',
    content: '<p>Первый большой митап сообщества собрал около 80 участников и шесть спикеров. За шесть часов поговорили о диалоговых моделях, медицинском AI, робототехнике, поиске, корпоративных ML-проектах и рынке труда.</p>',
    dateAdded: '2023-09-30T16:01:53.000Z',
    imageHeaderId: 'news-first-meetup',
    fullContent: telegramNewsContent[92],
    sourceUrl: 'https://t.me/dataDinnersTomsk/92',
    video: {
      embedUrl: 'https://www.youtube-nocookie.com/embed/0Iefawa1LNQ',
      title: 'ИИ от доставки до медицины: первый митап от Tomsk Data Science',
    },
  },
  {
    id: 'first-rebrand-meeting',
    header: 'Первая встреча нового сезона',
    content: '<p>После летнего перерыва собрались тринадцать участников. Обсудили планы сообщества, вход в ML, будущий митап и возвращение регулярных встреч.</p>',
    dateAdded: '2023-09-26T11:03:01.000Z',
    imageHeaderId: 'news-first-rebrand-meeting',
    fullContent: telegramNewsContent[90],
    sourceUrl: 'https://t.me/dataDinnersTomsk/90',
  },
  {
    id: 'rebrand',
    header: 'Дата-ужины стали Tomsk Data Science',
    content: '<p>После первого сезона сообщество выросло за пределы формата дата-ужинов и получило новое имя — Tomsk Data Science. Одновременно началась подготовка первого большого TDS Meetup.</p>',
    dateAdded: '2023-09-07T08:03:37.000Z',
    imageHeaderId: 'news-rebrand',
    fullContent: telegramNewsContent[82],
    sourceUrl: 'https://t.me/dataDinnersTomsk/82',
  },
  {
    id: 'first-year',
    header: 'Шестнадцать встреч за первый год',
    content: '<p>Менее чем за год сообщество провело шестнадцать встреч на пяти площадках, приблизилось к ста подписчикам и впервые выступило на DataFest.</p>',
    dateAdded: '2023-06-08T03:01:36.000Z',
    imageHeaderId: 'news-community-logo',
    fullContent: telegramNewsContent[77],
    sourceUrl: 'https://t.me/dataDinnersTomsk/77',
  },
  {
    id: 'chemistry-ai',
    header: 'Первый гибридный формат: Chemistry AI',
    content: '<p>Ксения, ML Researcher SCAMT ИТМО, рассказала о применении искусственного интеллекта в органической химии. Половина участников собралась в Akiba, остальные подключились онлайн.</p>',
    dateAdded: '2023-02-03T05:47:44.000Z',
    imageHeaderId: 'news-community-logo',
    fullContent: telegramNewsContent[47],
    sourceUrl: 'https://t.me/dataDinnersTomsk/47',
  },
  {
    id: 'reinforcement-learning',
    header: 'Основы reinforcement learning',
    content: '<p>На встрече в Akiba разобрали основы reinforcement learning и опыт запуска таких систем на реальных объектах, а затем обсудили студенческие соревнования по искусственному интеллекту.</p>',
    dateAdded: '2022-12-11T07:01:43.000Z',
    imageHeaderId: 'news-reinforcement-learning',
    fullContent: telegramNewsContent[41],
    sourceUrl: 'https://t.me/dataDinnersTomsk/41',
  },
  {
    id: 'magic-squares',
    header: 'Магические квадраты и теория чисел',
    content: '<p>Владимир Мынка рассказал о своём исследовании открытой задачи о магических квадратах: от методов теории чисел и разбора статей до генерации новых конструкций.</p>',
    dateAdded: '2022-11-23T19:06:24.000Z',
    imageHeaderId: 'news-magic-squares',
    fullContent: telegramNewsContent[34],
    sourceUrl: 'https://t.me/dataDinnersTomsk/34',
  },
  {
    id: 'medical-data',
    header: 'Медицинские данные и обработка сигналов',
    content: '<p>Иосиф Гузеев поделился опытом работы с медицинскими данными и обработкой сигналов. После доклада обсуждали теорию массового обслуживания и метрические методы.</p>',
    dateAdded: '2022-11-10T19:48:04.000Z',
    imageHeaderId: 'news-medical-data',
    fullContent: telegramNewsContent[27],
    sourceUrl: 'https://t.me/dataDinnersTomsk/27',
  },
  {
    id: 'speech-recognition',
    header: 'Распознавание речи и рекомендательные системы',
    content: '<p>На второй встрече сообщества говорили о распознавании речи, векторизации данных, музыкальных рекомендациях и поиске первых возможностей в Data Science.</p>',
    dateAdded: '2022-10-26T17:52:44.000Z',
    imageHeaderId: 'news-speech-recognition',
    fullContent: telegramNewsContent[23],
    sourceUrl: 'https://t.me/dataDinnersTomsk/23',
  },
  {
    id: 'first-data-dinner',
    header: 'Первый дата-ужин сообщества',
    content: '<p>Семь участников встретились, чтобы познакомиться и поговорить о компьютерном зрении в нефтегазовой отрасли, музыкальных рекомендациях, распознавании нот и способах войти в Data Science.</p>',
    dateAdded: '2022-10-19T18:06:55.000Z',
    imageHeaderId: 'news-first-data-dinner',
    fullContent: telegramNewsContent[16],
    sourceUrl: 'https://t.me/dataDinnersTomsk/16',
  },
  {
    id: 'community-launch',
    header: 'В Томске появилось сообщество о данных',
    content: '<p>13 октября 2022 года появился канал будущего Tomsk Data Science. Сообщество задумали как открытое место для встреч, докладов, воркшопов и обсуждения практических задач.</p>',
    dateAdded: '2022-10-13T18:59:09.000Z',
    imageHeaderId: 'news-community-launch',
    fullContent: telegramNewsContent[10],
    sourceUrl: 'https://t.me/dataDinnersTomsk/10',
  },
];
// END_DATA news

// END_MODULE repository_content
